export type AppConfig = {
  auth0Domain: string;
  auth0ClientId: string;
  auth0Audience: string;
  clientsUrl: string;
  usageUrl: string;
  postUrl: string;
  getUrl: string;
};

export class ConfigError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = 'ConfigError';
  }
}

const REQUIRED: Array<keyof AppConfig> = [
  'auth0Domain',
  'auth0ClientId',
  'auth0Audience',
  'clientsUrl',
  'usageUrl',
  'postUrl',
  'getUrl',
];

let cached: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  if (cached) return cached;
  const res = await fetch('/config.json', { cache: 'no-cache' });
  if (!res.ok) throw new ConfigError(`/config.json returned ${res.status}`);
  const json = (await res.json()) as Partial<AppConfig>;
  for (const key of REQUIRED) {
    if (!json[key] || typeof json[key] !== 'string') {
      throw new ConfigError(`/config.json is missing or invalid: ${key}`);
    }
  }
  cached = json as AppConfig;
  return cached;
}

export function __resetConfig() {
  cached = null;
}